// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".query-form .el-form-item[data-v-c69f707c]{margin-bottom:0!important}.newMatchDialog[data-v-c69f707c]  .el-form-item{margin-bottom:1.146vw!important}.el-menu[data-v-c69f707c]{background-color:#1e4683}.el-menu-item[data-v-c69f707c]{color:#fff}.el-menu-item[data-v-c69f707c]:focus,.el-menu-item[data-v-c69f707c]:hover{color:#000}", ""]);
// Exports
module.exports = exports;
